import { render, staticRenderFns } from "./yandex-metrika.vue?vue&type=template&id=8f49b8c6&"
import script from "./yandex-metrika.vue?vue&type=script&lang=js&"
export * from "./yandex-metrika.vue?vue&type=script&lang=js&"
import style0 from "./yandex-metrika.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports